const axios = require('axios');

import {SANTE_URL as baseUrl } from "src/modules/shared/config/config.service"

const SouscriptionSanteService = {
    /**
     * Récupère les informations de l'utilisateur
     */
    getUserInformations() {
        const url = baseUrl + '/souscription/user'
        return axios.get(url)
    },
    /**
     * Soumets le formulaire de souscription
     */
    submitForm(data, params) {
        const url = baseUrl + '/souscription/submit'
        return axios.post(url, data, {params: params})
    }
}

export default SouscriptionSanteService
